export const ALL_MANUFACTURERS_SEARCH_KEYWORD = '__all__';

export enum PRODUCT_CATEGORY {
    LINEAR = 'Linear',
    STRIP_LIGHT = 'Strip Light',
    DOWNLIGHT = 'Downlight',
    TROFFER = 'Troffer',
    PANEL = 'Panel',
    FLOODLIGHT_GRAZER = 'Floodlight / Grazer',
    FLEX_TAPE_CHANNEL = 'Flex / Tape / Channel',
    MULTIPLES = 'Multiples',
    AREA_SITE = 'Area / Site',
    HIGH_BAY_LOW_BAY = 'High Bay / Low Bay',
    STEPLIGHT = 'Steplight',
    COVE_PERIMETER = 'Cove / Perimeter',
    IN_GRADE = 'In-Grade',
    VANITY_LIGHT = 'Vanity Light',
    EXIT = 'Exit',
    EMERGENCY = 'Emergency',
    UNDER_CABINET_PUCK = 'Under Cabinet / Puck',
    WALLPACK = 'Wallpack',
    PARKING_GARAGE_CANOPY = 'Parking Garage / Canopy',
    CYLINDER = 'Cylinder',
    SCONCE = 'Sconce',
    WRAPAROUND = 'Wraparound',
    BOLLARD_PATH_LIGHT = 'Bollard / Path Light',
    LANDSCAPE = 'Landscape',
    FANS = 'Fans',
    FLUSH_MOUNT = 'Flush Mount',
    SEMI_FLUSH = 'Semi-Flush',
    ACCENT_TRACK_HEAD = 'Accent / Track Head',
    PENDANT_CHANDELIER = 'Pendant / Chandelier',
    FLOOR_LAMP = 'Floor Lamp',
    SPORTS_LIGHTER = 'Sports Lighter',
    GEOMETRICS = 'Geometric',
    DRUMS = 'Drums'
}

export const PRODUCT_CATEGORY_LIST = [
    PRODUCT_CATEGORY.ACCENT_TRACK_HEAD,
    PRODUCT_CATEGORY.AREA_SITE,
    PRODUCT_CATEGORY.BOLLARD_PATH_LIGHT,
    PRODUCT_CATEGORY.COVE_PERIMETER,
    PRODUCT_CATEGORY.CYLINDER,
    PRODUCT_CATEGORY.DOWNLIGHT,
    PRODUCT_CATEGORY.DRUMS,
    PRODUCT_CATEGORY.EMERGENCY,
    PRODUCT_CATEGORY.EXIT,
    PRODUCT_CATEGORY.FANS,
    PRODUCT_CATEGORY.FLEX_TAPE_CHANNEL,
    PRODUCT_CATEGORY.FLOODLIGHT_GRAZER,
    PRODUCT_CATEGORY.FLOOR_LAMP,
    PRODUCT_CATEGORY.FLUSH_MOUNT,
    PRODUCT_CATEGORY.GEOMETRICS,
    PRODUCT_CATEGORY.HIGH_BAY_LOW_BAY,
    PRODUCT_CATEGORY.IN_GRADE,
    PRODUCT_CATEGORY.LANDSCAPE,
    PRODUCT_CATEGORY.LINEAR,
    PRODUCT_CATEGORY.MULTIPLES,
    PRODUCT_CATEGORY.PANEL,
    PRODUCT_CATEGORY.PARKING_GARAGE_CANOPY,
    PRODUCT_CATEGORY.PENDANT_CHANDELIER,
    PRODUCT_CATEGORY.SCONCE,
    PRODUCT_CATEGORY.SEMI_FLUSH,
    PRODUCT_CATEGORY.SPORTS_LIGHTER,
    PRODUCT_CATEGORY.STEPLIGHT,
    PRODUCT_CATEGORY.STRIP_LIGHT,
    PRODUCT_CATEGORY.TROFFER,
    PRODUCT_CATEGORY.UNDER_CABINET_PUCK,
    PRODUCT_CATEGORY.VANITY_LIGHT,
    PRODUCT_CATEGORY.WALLPACK,
    PRODUCT_CATEGORY.WRAPAROUND
] as const;

export const PRODUCT_CATEGORY_SET = new Set(PRODUCT_CATEGORY_LIST);

export const PRODUCT_APPLICATION = ['Architectural', 'Decorative', 'Industrial'] as const;

export const PRODUCT_MOUNTING_TYPE = [
    'Adjustable',
    'Arm',
    'Knuckle / Yoke / Trunnion',
    'Monopoint',
    'Recessed',
    'Semi-Recessed',
    'Surface',
    'Wall',
    'Ground / Floor',
    'Suspended / Cable / Chain / Stem / Pendant',
    'T-Bar Grid',
    'Track',
    'Flange / Trimmed',
    'Trimless',
    'Stake',
    'Retrofit',
    'Magnetic',
    'Pole / Stanchion / Tenon',
    'Clamp / Hook / Strap'
] as const;

export const MOUNTING_TYPE_SET = new Set(PRODUCT_MOUNTING_TYPE);

export const PRODUCT_DIMMING_PROTOCOL = [
    '0-10V',
    '1-10V',
    'Triac',
    'ELV (Electronic Low Voltage)',
    'MLV (Magnetic Low Voltage)',
    'Lutron',
    'DALI',
    'DMX',
    'PWM',
    'Forward Phase',
    'Reverse Phase',
    'Touch',
    'Pull Chain',
    'In-Line On/Off',
    'Hand Motion',
    'Bulb Dependent',
    'UniDim',
    'Warm Dim / Adjustable White',
    'Full Range Dimmer Switch',
    'Wireless (Bluetooth, Zigbe, Casambi)'
] as const;

export const PRODUCT_DIMMING_RANGE = ['Bi-Level', 'Dim to <1%', 'Dim to 1%', 'Dim to 5-10%', 'Dim to ≥ 11%', 'Multi Switching', 'Step Dim', 'Dim-to-Dark', 'Non-Dimmable'] as const;

export const PRODUCT_VOLTAGE = [
    'Other Low Voltage',
    '12v',
    '24v',
    '12-24v',
    '36v',
    '100-110v',
    '100-240v',
    '100-277v MVOLT',
    '100-347v',
    '120-240v',
    '120-277v UNV / MVOLT',
    '120-347v',
    '120v',
    '120-250v',
    '125v',
    '200-480v',
    '220-240v',
    '277-480v HVOLT',
    '277v',
    '347v',
    '347-480v HVOLT',
    '400v',
    '480v',
    'Other High Voltage'
] as const;

export const PRODUCT_ENVIRONMENT = [
    'Healthcare / Patient Rooms',
    'Outdoor',
    'Hazardous',
    'Cleanroom',
    'Damp',
    'Classroom / Educational Facilities',
    'Wet',
    'Food Processing',
    'Marine',
    'MRI-Safe',
    'Pool / Spa',
    'Dry',
    '2HR Fire Rated',
    'ADA',
    'IC',
    'CA Title 24',
    'CCEA Chicago Plenum',
    'Energy Star',
    'IP67',
    'IP65',
    'IP66',
    'IP68',
    'IP69K',
    'JA8',
    'Non-IC'
] as const;

export const LUMEN_UNITS = [
    { label: 'Lumens', value: 'lm' },
    { value: 'lm/ft', label: 'Lumens/Feet' },
    { label: 'Lumens/Meter', value: 'lm/meter' }
];

export const MULTI_VALUE_CATEGORIES: { [key: string]: readonly string[] } = {
    'Linear / Strip': ['Linear', 'Strip Light', 'Linear / Strip'],
    'Under Cabinet / Puck': ['Under Cabinet / Puck', 'Under Cabinet'],
    'Floodlight / Grazer': ['Floodlight', 'Floodlight / Grazer']
};

export const MULTI_VALUE_MOUNTING_TYPE: { [key: string]: readonly string[] } = {
    'Knuckle / Yoke / Trunnion': ['Knuckle / Yoke', 'Knuckle / Yoke / Trunnion'],
    'Ground / Floor': ['Floor', 'Ground / Floor'],
    'Clamp / Hook / Strap': ['Clamp', 'Clamp / Hook / Strap']
};

export const DOWNLIGHT_CYLINDER_DIMENSIONS = ['1” and lower', '2”', '3”', '4”', '5”', '6”', '8”', '10” and higher'] as const;
export const FLEX_TAPE_CHANEL_DIMENSIONS = ['0.5” and lower', '0.5” - 1.0”', '1.0” and higher'] as const;
export const PANEL_DIMENSIONS = ["1' x 4'", "2' x 2'", "2' x 4'"] as const;
